import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class SmartVehicleInspection {
  /* 车辆影像档案列表 */
  static getCarArchive(options) {
    let url = `/zwy/api/vehicle/inspect/record/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 车辆影像档案详情 */
  static getCarArchiveDetails(id) {
    let url = `/zwy/api/vehicle/inspect/record/${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 采集人员列表 */
  static getCollectList(options) {
    let url = `/zwy/api/vehicle/inspect/collector/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增采集人员 */
  static postAddCollect(data) {
    const url = `/zwy/api/vehicle/inspect/collector/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 编辑采集人员 */
  static postModCollect(data) {
    const url = `/zwy/api/vehicle/inspect/collector/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 更新采集人员状态 */
  static postUpdateCollectStatus(data) {
    const url = `/zwy/api/vehicle/inspect/collector/update/status`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }

  /* 采集看板详情 */
  static getKanbanDetails(id, options) {
    let url = `/zwy/api/vehicle/inspect/batch/${id}/progress?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }

  /* 批次列表 */
  static getBatchList(options) {
    let url = `/zwy/api/vehicle/inspect/batch/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增批次
  static postAddBatch(data) {
    const url = `/zwy/api/vehicle/inspect/batch/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑批次
  static postModBatch(data) {
    const url = `/zwy/api/vehicle/inspect/batch/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 导入批次号
  static postUploadBatchExcel(id, data) {
    const url = `/zwy/api/vehicle/inspect/batch/${id}/vin/import`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 批次详情 */
  static getBatchDetails(id) {
    let url = `/zwy/api/vehicle/inspect/batch/${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }

  /* 品牌列表 */
  static getBrandList(options) {
    let url = `/zwy/api/vehicle/inspect/brand/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增品牌 */
  static postAddBrand(data) {
    const url = `/zwy/api/vehicle/inspect/brand/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 编辑品牌 */ 
  static postModBrand(data) {
    const url = `/zwy/api/vehicle/inspect/brand/update`; 
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 更新品牌状态 */
  static postUpdateBrandStatus(data) {
    const url = `/zwy/api/vehicle/inspect/brand/update/status`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }

}

export default SmartVehicleInspection;